export default __webpack_public_path__ + "static/media/x.cb694a22.svg";